/**
 * Chutt... - Chart Explainer Content Dictionary
 * Each entry: { title, description, howToRead, actions[] }
 */

export const chartExplainerContent = {
  // ===== Dashboard =====
  mentionsTrend: {
    title: 'Tendance des mentions',
    description: 'Evolution du nombre de mentions de votre marque au fil du temps. Chaque point represente le total quotidien.',
    howToRead: 'Une courbe ascendante indique un interet croissant. Un pic soudain peut signaler un buzz ou une crise.',
    actions: [
      'Investiguer tout pic anormal (positif ou negatif)',
      'Comparer avec vos actions marketing recentes',
    ],
  },
  shareOfVoice: {
    title: 'Part de voix',
    description: 'Repartition des mentions entre votre marque et les concurrents ou sujets connexes.',
    mission: 'Rayonner',
    howToRead: 'Plus votre part est grande, plus vous dominez la conversation dans votre secteur.',
    actions: [
      'Augmenter votre visibilite si la part de voix est inferieure a 30%',
      'Identifier les sujets ou les concurrents captent l\'attention',
    ],
  },
  segmentWheel: {
    title: 'Roue des segments',
    description: 'Repartition de vos mentions par segment (presse, reseaux sociaux, forums, blogs...).',
    mission: 'Federer',
    howToRead: 'Un segment dominant indique ou se joue votre reputation. L\'equilibre est signe de bonne diversification.',
    actions: [
      'Renforcer votre presence sur les segments sous-representes',
      'Surveiller les segments a fort volume negatif',
    ],
  },
  trendingKeywords: {
    title: 'Mots-cles tendance',
    description: 'Les termes les plus frequemment associes a votre marque ces derniers jours. Les mots-cles revelent les sujets qui faconnent votre reputation.',
    howToRead: 'Les mots en gras ou plus gros apparaissent le plus souvent. Couleur verte = positif, rouge = negatif.',
    actions: [
      'Capitaliser sur les mots-cles positifs dans votre communication',
      'Adresser rapidement les termes negatifs recurrents',
    ],
  },
  drivers: {
    title: 'Facteurs de reputation',
    description: 'Sujets et themes qui influencent le plus votre score de reputation, positivement ou negativement.',
    howToRead: 'Les barres vertes sont des leviers positifs a renforcer. Les barres rouges sont des risques a traiter.',
    actions: [
      'Amplifier les drivers positifs (temoignages, articles favorables)',
      'Creer un plan d\'action pour chaque driver negatif',
    ],
  },

  // ===== Scorecard =====
  repScore: {
    title: 'Score de reputation',
    description: 'Note synthetique de 0 a 100 combinant sentiment, volume et portee des mentions.',
    howToRead: '75+ = Excellent, 60-74 = Bon, 40-59 = Moyen, <40 = Critique. Comparez avec le mois precedent.',
    actions: [
      'Viser un score stable au-dessus de 60',
      'En dessous de 40, activez un plan de crise',
    ],
  },
  missionProtect: {
    title: 'Mission: Proteger',
    description: 'Mesure votre capacite a reduire les mentions negatives, controler les SERP et reagir vite aux crises.',
    howToRead: 'Score pondere des 4 sous-objectifs: reduction negatifs (30%), SERP (30%), SEO (20%), temps de reponse (20%).',
    actions: [
      'Surveiller les alertes negatives quotidiennement',
      'Publier du contenu positif pour pousser les resultats negatifs',
    ],
  },
  missionVisibility: {
    title: 'Mission: Rayonner',
    description: 'Mesure votre capacite a generer des mentions, obtenir une couverture presse et diversifier vos sources.',
    howToRead: 'Score pondere: volume (40%), couverture media (35%), diversification (25%).',
    actions: [
      'Planifier des communiques de presse reguliers',
      'Developper votre presence sur de nouvelles plateformes',
    ],
  },
  missionTrust: {
    title: 'Mission: Inspirer confiance',
    description: 'Mesure la qualite du sentiment autour de votre marque (NSS et ratio positif).',
    howToRead: 'Score pondere: NSS (55%), ratio positif (45%). Un NSS positif signifie plus de mentions positives que negatives.',
    actions: [
      'Encourager les avis positifs et temoignages',
      'Repondre aux mentions negatives avec empathie',
    ],
  },
  missionCommunity: {
    title: 'Mission: Federer',
    description: 'Mesure l\'engagement de votre communaute et la visibilite aupres des influenceurs.',
    howToRead: 'Score pondere: engagement (55%), mentions influenceurs (45%).',
    actions: [
      'Creer du contenu interactif (sondages, Q&A)',
      'Identifier et engager les micro-influenceurs de votre secteur',
    ],
  },
  sentimentBar: {
    title: 'Repartition du sentiment',
    description: 'Proportion de mentions positives, neutres et negatives sur la periode selectionnee.',
    howToRead: 'Vert = positif, gris = neutre, rouge = negatif. Un ratio positif >50% est un bon signe.',
    actions: [
      'Investiguer si les mentions negatives depassent 25%',
      'Identifier les sources principales de negativite',
    ],
  },
  sourcePie: {
    title: 'Sources de mentions',
    description: 'Repartition de vos mentions par plateforme (Twitter, presse, Facebook, etc.).',
    howToRead: 'Un camembert equilibre indique une bonne diversification. Une dependance a une seule source est un risque.',
    actions: [
      'Renforcer votre presence sur les plateformes sous-representees',
      'Concentrer les efforts sur les plateformes a fort engagement',
    ],
  },

  // ===== Comprendre =====
  sentimentEvolution: {
    title: 'Evolution du sentiment',
    description: 'Courbe du Net Sentiment Score au fil du temps.',
    howToRead: 'Au-dessus de 0 = sentiment net positif. Surveillez les chutes brutales qui signalent une crise.',
    actions: [
      'Corréler les variations avec vos actions de communication',
      'Reagir dans les 24h a toute chute significative',
    ],
  },
  topicCloud: {
    title: 'Nuage de sujets',
    description: 'Visualisation des themes principaux associes a votre marque, ponderes par frequence.',
    howToRead: 'Plus un mot est gros, plus il est mentionne. Les couleurs indiquent le sentiment dominant.',
    actions: [
      'Explorer les sujets emergents pour detecter les tendances',
      'Creer du contenu autour des sujets positifs populaires',
    ],
  },

  // ===== Drivers =====
  positiveDrivers: {
    title: 'Leviers positifs',
    description: 'Les sujets et themes qui ameliorent le plus votre reputation.',
    howToRead: 'Plus la barre est longue, plus le sujet est mentionne positivement. Ce sont vos atouts.',
    actions: [
      'Capitaliser sur ces themes dans votre communication',
      'Partager les articles/mentions les plus positifs',
    ],
  },
  negativeDrivers: {
    title: 'Points de friction',
    description: 'Les sujets et themes qui degradent le plus votre reputation.',
    howToRead: 'Plus la barre est longue, plus le sujet est mentionne negativement. Ce sont vos risques.',
    actions: [
      'Creer un plan de reponse pour chaque sujet negatif',
      'Surveiller l\'evolution de ces sujets quotidiennement',
    ],
  },

  // ===== SEO =====
  serpResults: {
    title: 'Resultats SERP',
    description: 'Analyse des 10 premiers resultats Google pour votre marque.',
    howToRead: 'Vert = resultat positif/neutre, rouge = resultat negatif. Visez >70% de resultats positifs en page 1.',
    actions: [
      'Publier du contenu optimise SEO pour pousser les resultats negatifs',
      'Mettre a jour vos profils officiels (Google Business, LinkedIn)',
    ],
  },
  campaigns: {
    title: 'Campagnes SEO/RP',
    description: 'Suivi de vos campagnes de contenu et de relations presse.',
    howToRead: 'Chaque campagne montre son statut (active, terminee) et ses metriques de performance.',
    actions: [
      'Lancer une nouvelle campagne si aucune n\'est active',
      'Evaluer le ROI des campagnes terminees',
    ],
  },

  // ===== Radar =====
  radarOverview: {
    title: 'Score de Reputation (Score RP)',
    description: 'Note synthetique de 0 a 100 qui combine : le sentiment net (NSS, 40%), le volume de mentions (20%), la maitrise des resultats Google / SERP (20%) et l\'engagement communautaire (20%).',
    howToRead: '75+ = Excellent (soleil). 50-74 = Correct (nuageux). <50 = Alerte (orage). La fleche indique la tendance en % par rapport a la moyenne du mois precedent — vert = hausse, rouge = baisse.',
    actions: [
      'Si le score baisse : identifier le facteur (NSS, SERP, volume) et agir en priorite',
      'Comparer chaque semaine pour detecter les tendances de fond',
    ],
  },
  nssScore: {
    title: 'Score NSS (Net Sentiment Score)',
    description: 'Mesure l\'equilibre entre mentions positives et negatives. Un NSS de +50 signifie nettement plus de positif que de negatif.',
    mission: 'Inspirer Confiance',
    howToRead: 'Au-dessus de +20 = bonne perception. Entre 0 et +20 = fragile. Negatif = alerte. La tendance est exprimee en % de hausse ou baisse par rapport a la moyenne du mois.',
    actions: [
      'Encourager les temoignages positifs si NSS < 20',
      'Traiter les sources de negatif en priorite si NSS < 0',
    ],
  },
  mentionsVolume: {
    title: 'Volume de Mentions',
    description: 'Nombre total de mentions captees sur toutes les sources surveillees (presse, reseaux sociaux, web).',
    mission: 'Rayonner',
    howToRead: 'Plus le volume est eleve, plus on parle de vous. Un pic soudain peut signaler un buzz ou une crise. La tendance est exprimee en % de hausse ou baisse par rapport a la moyenne du mois.',
    actions: [
      'Augmenter les prises de parole si le volume stagne',
      'Investiguer les pics anormaux',
    ],
  },
  serpScore: {
    title: 'SERP Score (Score Google)',
    description: 'Pourcentage de resultats positifs/neutres dans le Top 10 Google pour votre nom. C\'est ce que voit quelqu\'un qui vous cherche.',
    mission: 'Proteger',
    howToRead: '≥60% = bonne maitrise. 30-60% = a consolider. <30% = resultats defavorables a traiter d\'urgence.',
    actions: [
      'Publier du contenu SEO pour pousser les resultats negatifs',
      'Mettre a jour vos profils officiels',
    ],
  },
  trendPredictions: {
    title: 'Tendances Detectees',
    description: 'Sujets emergents autour de votre marque, avec prediction de l\'evolution (pic, hausse, stable). Detecte aussi les risques de crise.',
    howToRead: 'Rouge \'Pic detecte\' = sujet viral, surveillez de pres. Vert \'En hausse\' = tendance positive a amplifier. Toutes les tendances sont exprimees en % de hausse (vert) ou baisse (rouge) par rapport a la moyenne mensuelle.',
    actions: [
      'Preparer une reponse pour les tendances a probabilite de crise >30%',
      'Capitaliser sur les tendances positives avec du contenu cible',
    ],
  },
  mentionsRecentes: {
    title: 'Mentions Recentes',
    description: 'Flux en temps reel des dernieres mentions de votre marque sur toutes les plateformes surveillees.',
    howToRead: 'Chaque carte montre la source, le sentiment (positif/neutre/negatif) et un extrait. Filtrez par plateforme ou sentiment.',
    actions: [
      'Repondre aux mentions negatives dans les 24h',
      'Partager ou remercier les mentions positives',
    ],
  },
  crisisTimeline: {
    title: 'Timeline de crise',
    description: 'Chronologie des alertes et evenements de crise detectes pour votre marque.',
    howToRead: 'Les points rouges indiquent des crises actives. Les verts sont resolues. La taille indique la severite.',
    actions: [
      'Resoudre les crises actives dans les 24h',
      'Documenter les lecons apprises apres chaque crise',
    ],
  },
};

export default chartExplainerContent;
